import { isString } from 'lodash';
import store from '@/store'
function checkPermission(el, binding) {
  const { value } = binding
  const auths = store.getters && store.getters.auths
  console.log(auths, 'sssssssss');

  if (!value.trim()) {
    el.parentNode && el.parentNode.removeChild(el)
    return;
  }
  if (!isString(value)) {
    throw new Error(`v-auth 书写错误!"`)
  }
  let auth = value.trim();

  if (!auths.includes(auth)) {
    el.parentNode && el.parentNode.removeChild(el)
  }
}


/**
 * 权限指令
 */
export default function (app) {
  console.log("[v-auth reg]")
  app.directive('auth', {
    created(el, binding) {
      console.log("[inserted auth]")
      checkPermission(el, binding)
    },
    updated(el, binding) {
      console.log("[inserted update]")
      checkPermission(el, binding)
    }
  })
}




